package com.neurobs.ccabserver.administrator.components

import com.neurobs.ccabserver.administrator.contexts.MenuState.MenuItemType
import com.neurobs.ccabserver.administrator.contexts.{MenuContext, MenuState, ResourceURLContext, ServerContext, UserContext}
import com.neurobs.js.aws.Amplify
import com.neurobs.react.{GapSize, HoriAlign, LTFullRow, LayoutTable, includeIf}
import slinky.core.FunctionalComponent
import slinky.core.annotations.react
import slinky.core.facade.ReactElement
import slinky.web.html.{alt, className, div, img, src}

import scala.util.Try

object Application {
	@react object LoginContent {
		type Props = Unit
		val component = FunctionalComponent[Props] { props =>
			val resources = ResourceURLContext.accessState()

			div(className := "nfw-centered-container")(
				div(
					className := "nfw-login-container"
				)(
					div(img(className := "nfw-login-logo", src := resources.get(ResourceURLContext.Resource.CircleLogoWithText), alt := "Logo")),
					Amplify.Authenticator(hideSignUp = 1)
				)
			)
		}
	}

	@react object View {
		case class Props ()

		val component = FunctionalComponent[Props] { props =>
			val user = UserContext.accessState()
			val server = ServerContext.accessState()
			val menu = MenuContext.accessState()

			val content: ReactElement = user.user match {
				case None => LoginContent()
				case Some(_) =>
					div(
						ContentArea(menu.value.selection),
						includeIf(menu.value.selection.isDefined)(
							div(className := "nfw-examiner-spacer")
						),
						ExaminerSet()
					)
			}

			def logout(): Unit = {
				user.value.manager.logout()
			}

			def setSelection(c: String): Unit = {
				val t = Try(MenuItemType.withName(c)).toOption
				if (t.contains(MenuItemType.Examiner)) menu.set(selection = None, menuVisible = false)
			else if (t.contains(MenuItemType.Resources)) {
				// Open Resources in a new tab without changing selection
				org.scalajs.dom.window.open("/user_support/index.html", "_blank")
			} else menu.setSelection(t)
		}

		NavFramework.View(
				sections = MenuState.baseMenu,
				user = user.user,
				alerts = menu.value.alerts.map(_.toString),
				selections = menu.value.selection.map(t => Seq(t.toString)).getOrElse(Seq()),
				onLogoutClicked = () => logout(),
				onSelection = c => setSelection(c),
				content = content
			)
		}
	}
}
